<p-panel [toggleable]="true">
  <ng-template pTemplate="header">
    <div class="report-card-header">
      <span class="report-icon"><i class="fa fa-download"></i></span>
      <span class="report-card-title">Export comparison report (CSV)</span>
    </div>
  </ng-template>
  <div class="report-card-body">
    <div class="report-filters">
      <div class="report-filter-field">
        <p-floatLabel>
          <p-multiSelect [(ngModel)]="selectedClients" [options]="uniqCompanyItems"
                         name="uniqCompanyItems" required></p-multiSelect>
          <label>Clients</label>
        </p-floatLabel>
      </div>
      <div class="report-filter-field">
        <p-floatLabel>
          <p-calendar [(ngModel)]="dateFilterFrom" dateFormat="mm/yy" name="dateFilterFrom" required
                      view="month"></p-calendar>
          <label>From</label>
        </p-floatLabel>
      </div>
      <div class="report-filter-field">
        <p-floatLabel>
          <p-calendar [(ngModel)]="dateFilterTo" dateFormat="mm/yy" name="dateFilterTo" required
                      view="month"></p-calendar>
          <label>To</label>
        </p-floatLabel>
      </div>
      <div class="report-filter-field">
        <p-floatLabel>
          <p-multiSelect [(ngModel)]="selectedExchanges" [filter]="false"
                         [options]="uniqExchangeItems" maxSelectedLabels="2" name="selectedExchanges"
                         required></p-multiSelect>
          <label>Exchange</label>
        </p-floatLabel>
      </div>
    </div>
    <button (click)="exportCSV()" [disabled]="selectedExchanges.length < 1" class="report-export-btn"
            icon="fa fa-download pr-2" iconPos="left" label="Export"
            pButton type="button"></button>
  </div>
</p-panel>
